export enum NotificationType {
  APROBADO = "1",
  RECHAZADO = "2",
}
